import { useEffect, useState } from "react";
import { useSetFaviconHref } from "../provider/FaviconProvider.tsx";
import useAiChatReasoningStatus from "./useAiChatReasoningStatus.ts";
import { useAiChat } from "../provider/AiChatProvider.tsx";

const useAiChatFavicon = () => {
  const faviconByReasoningState = {
    default: ["/favicon.ico"],
    loading: ["/favicon-loading-dark.ico", "/favicon-loading-light.ico"],
    alert: ["/favicon-ready.ico"],
  };

  const [faviconIndex, setFaviconIndex] = useState<0 | 1>(0);
  const [triggerAiChatReasoningStatusRead, setTriggerAiChatReasoningStatusRead] = useState<number>(0);
  const { activeThreadId } = useAiChat();
  const setFaviconHref = useSetFaviconHref();
  const { setIndicatorType, indicatorType } = useAiChatReasoningStatus(
    activeThreadId,
    triggerAiChatReasoningStatusRead,
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIndicatorType(null);
      } else {
        setTriggerAiChatReasoningStatusRead((prevState) => ++prevState);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (indicatorType !== "loading") {
      return;
    }

    const intervalId = setInterval(() => {
      setFaviconIndex((currentIndex) => (currentIndex === 0 ? 1 : 0));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [indicatorType]);

  useEffect(() => {
    const faviconState = document.visibilityState === "hidden" && indicatorType ? indicatorType : "default";
    setFaviconHref(faviconByReasoningState[faviconState][indicatorType === "loading" ? faviconIndex : 0]);
  }, [indicatorType, faviconIndex]);

  useEffect(() => {
    return () => {
      //reset to default on unmount
      setFaviconHref(faviconByReasoningState.default[0]);
    };
  }, []);
};

export default useAiChatFavicon;
